// extracted by mini-css-extract-plugin
export default {"menuBlock":"RE-z","title":"SE-z","nav":"TE-z","flexCell":"UE-z","facetLink":"VE-z"};